import {LocaleInfoModel} from "../components/localization/interface";

export const defaultLocalCode = "tr-TR";
export const defaultLanguageCode = "tr";
export const defaultCountryCode = "TR";
export const defaultLocale: LocaleInfoModel = {
    languageCode: defaultLanguageCode,
    name: 'Turkish',
    icon: defaultLanguageCode,
    locale: defaultLocalCode,
    countryCode: defaultCountryCode,
    localeDateTimeFormat: "dd.MM.yyyy HH:mm:ss",
    localeDateFormat: "dd.MM.yyyy",
    timeFormat: "HH:mm:ss",
};